module.exports = __webpack_public_path__ + "static/media/logo4.c4414e2a.png";